module.exports = __webpack_public_path__ + "img/bg-green-xl.df9be835.jpg";